<!--
 * @version: V1.0.0
 * @Date: 2023-10-27 16:50:49
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-02 13:50:22
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\traceability\index.vue
 * @Descripttion:
-->

<template>
  <div v-loading.fullscreen="loading" class="list" element-loading-text="加载中">
    <el-card>
      <div class="bigser-box">
        <div class="title"> 输入UDI或订单编号后，查询对应的UDI出入库溯源信息</div>
        <el-input v-model="queryKeyword" placeholder="请输入内容"
          @keyup.enter.native="() => { searchParam.pageNum = 1; search() }">
          <el-select slot="prepend" v-model="queryKey" style="width: 120px;" placeholder="请选择"
            @change="pageListData = []">
            <el-option label="订单编号" value="orderCode"></el-option>
            <el-option label="UDI码" value="completeUdi"></el-option>
            <el-option label="产品名称" value="productName"></el-option>
            <el-option label="客户名称" value="customerName"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="() => { searchParam.pageNum = 1; search() }"></el-button>
        </el-input>
      </div>
    </el-card>
    <el-card>
      <DITable v-if="queryKey === 'orderCode' || queryKey === 'completeUdi'" :search-param="searchParam"
        :page-list-data="pageListData" :dict-obj="dictObj" :height-style-obj="heightStyleObj"></DITable>
      <el-table v-else ref="dataTable" :height="heightStyleObj" :data="pageListData" highlight-current-row border
        style="width:100%;margin-top: 10px">
        <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
          <template slot-scope="{ $index }">
            {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="productName" width="120px" show-overflow-tooltip label="物料名称" />
        <el-table-column width="140px" prop="diCode" show-overflow-tooltip label="产品DI" />
        <el-table-column width="120px" prop="lot" show-overflow-tooltip label="批号" />
        <el-table-column width="120px" prop="packLevel" show-overflow-tooltip label="产品单位" />
        <el-table-column min-width="100px" prop="customerName" show-overflow-tooltip label="客户名称" />
        <el-table-column show-overflow-tooltip prop="used" label="业务类型" />
        <el-table-column show-overflow-tooltip label="发货日期">
          <template slot-scope="scope">
            {{ parseTime(scope.row.specifyDeliveryDate, '{y}-{m}-{d}') }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="orderCode" min-width="120px" label="单据编号">
          <template slot-scope="scope">
            <el-button v-if="['SCRK', 'SMRK', 'YHCK'].includes(scope.row.operationType)" @click="showOrderInfo(scope.row)">{{ scope.row.orderCode }}</el-button>
            <span v-else>{{ scope.row.orderCode }}</span>
          </template>
        </el-table-column>
        <el-table-column width="160px" show-overflow-tooltip label="">
          <template slot-scope="scope">
            <el-button @click="showDetail(scope.row)">查看订单详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page-sizes="[10, 20, 50, 100]" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="search" />
    </el-card>
    <detail v-if="detailShow" :height-style-obj="heightStyleObj" :dict-obj="dictObj" :visible="detailShow"
      :order-info="orderInfo" @close="close"></detail>
    <orderInfo
      v-if="orderInfoVisible"
      :visible="orderInfoVisible"
      :dict-obj="dictObj"
      :operationType="orderInfo.operationType"
      :order-id="orderInfo.orderId"
      @close="orderInfoVisible=false" />
  </div>
</template>
<script>
import { getDict } from '@/api/common'
import DITable from './components/DITable'
import detail from './components/detail.vue'
import { getTraceabilityDataByProductName, getTraceabilityDataByCustomerName } from '@/api/trace'
import { getTraceabilityData } from '../../api/trace'
import orderInfo from "@/views/traceability/components/orderInfo.vue";
export default {
  name: 'TraceabilityList',
  components: { orderInfo, DITable, detail },
  data() {
    return {
      dictObj: {
        delivery_status: [],
        operation_type: [],
        warehouseType: [],
        inType: []
      },
      orderInfo: {},
      detailShow: false,
      heightStyleObj: 0,
      queryKey: 'orderCode',
      queryKeyword: '',
      loading: false,
      pageListData: [],
      orderInfoVisible: false,
      searchParam: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.heightStyleObj = window.innerHeight - 405 + 'px'
    })

    this.getDicts(['delivery_status', 'operation_type','warehouseType','inType'])
  },
  methods: {
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
        })
      })
    },
    search() {
      if (this.queryKey !== 'orderCode' && this.queryKey !== 'completeUdi') {
        this.getOrderListData()
      } else {
        this.getPageListData()
      }
    },
    // 查询订单层级数据
    getOrderListData() {
      if (!this.queryKeyword) return this.$message.error('内容不可为空')
      const params = { ...this.searchParam }
      params[this.queryKey] = this.queryKeyword
      this.loading = true
      if (this.queryKey === 'customerName') {
        getTraceabilityDataByCustomerName(params).then(res => {
          this.pageListData = res.rows
          this.total = res.total
        }).finally(() => {
          this.loading = false
        })
      } else if (this.queryKey === 'productName') {
        getTraceabilityDataByProductName(params).then(res => {
          this.pageListData = res.rows
          this.total = res.total
        }).finally(() => {
          this.loading = false
        })
      } else {
        getTraceabilityData(params).then(res => {
          this.pageListData = res.rows
          this.total = res.total
        }).finally(() => {
          this.loading = false
        })
      }


    },
    showDetail(row) {
      this.detailShow = true;
      this.orderInfo = row;
    },
    close() {
      this.detailShow = false;
      this.orderInfo = {};
    },
    // 获取详细udi数据
    getPageListData() {
      if (!this.queryKeyword) return this.$message.error('内容不可为空')
      const params = { ...this.searchParam }
      params[this.queryKey] = this.queryKeyword
      this.loading = true
      getTraceabilityData(params).then(res => {
        this.pageListData = res.rows
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    showOrderInfo(row) {
      this.orderInfo = row
      this.orderInfoVisible = true
    }
  }
}
</script>
